"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tag = void 0;
const basic_1 = require("../basic");
const colors_1 = require("../basic/colors");
exports.tag = (0, basic_1.applyBase)({
    removableTagWrapper: {
        transition: 'border-color 0.2s ease-in',
        '.removableTagLabel': {
            textDecoration: 'underline 1px rgba(0,0,0,0)',
            textUnderlineOffset: '2px',
            transition: 'text-decoration-color 0.2s ease-in',
        },
        '&:hover': {
            borderColor: colors_1.baseColors.black,
            '.removableTagLabel': {
                textDecorationColor: colors_1.baseColors.black,
            },
        },
        '&:focus': {
            borderColor: colors_1.baseColors.black,
            px: '7px',
            borderWidth: '2px',
            '.removableTagLabel': {
                textDecorationColor: colors_1.baseColors.black,
            },
        },
    },
});
//# sourceMappingURL=tag.js.map